export const translation = {
  zenit: {
    ae: {
      siteTitle: "المراهنات الرياضية | Zenit",
      btnLogin: "تسجيل الدخول",
      btnSignup: "سجّل",
      title: "راهن مع وكيل المراهنات Zenit",
      subtitle: "3 خطوات بسيطة لتبدأ المراهنة:",
      stepTitle1: "سجّل",
      stepSubtitle1: "أنشئ حسابًا في بضع دقائق فقط",
      stepTitle2: "أودع",
      stepSubtitle2: "أودع باستخدام أي وسيلة متاحة",
      stepTitle3: "راهن",
      stepSubtitle3: "اختر النتائج وراهن على أفضل الأحداث",
      btnGet: "سجّل",
      regFormTitle: `Register
        and make bets!`
    },
    bn: {
      siteTitle: "ক্রীড়া বাজি | Zenit",
      btnLogin: "সাইন ইন করুন",
      btnSignup: "নিবন্ধন করুন",
      title: "বুকমেকার ZENIT-এর সাথে বাজি ধরুন",
      subtitle: "বাজি শুরু করার 3 টি সহজ পদক্ষেপ:",
      stepTitle1: "নিবন্ধন করুন",
      stepSubtitle1: "মাত্র কয়েক মিনিটে অ্যাকাউন্ট তৈরি করুন।",
      stepTitle2: "জমা করুন",
      stepSubtitle2: "যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে জমা করুন।",
      stepTitle3: "বাজি ধরুন",
      stepSubtitle3: "ফলাফল বেছে নিন এবং শীর্ষ ইভেন্টগুলোতে বাজি ধরুন।",
      btnGet: "নিবন্ধন করুন",
      regFormTitle: `Register
        and make bets!`
    },
    br: {
      siteTitle: "Apostas esportivas | Bookmaker Zenit",
      btnLogin: "LOGIN",
      btnSignup: "REGISTRE-SE",
      title: "FAÇA APOSTAS COM A CASA DE APOSTAS ZENIT",
      subtitle: "3 passos fáceis para começar a apostar:",
      stepTitle1: "REGISTRE-SE AGORA",
      stepSubtitle1: "Crie uma conta em alguns minutos.",
      stepTitle2: "Faça um depósito",
      stepSubtitle2: "Faça um depósito usando qualquer método disponível.",
      stepTitle3: "FAÇA APOSTAS",
      stepSubtitle3: "Escolha os resultados e faça apostas nos principais eventos.",
      btnGet: "REGISTRE-SE",
      regFormTitle: `REGISTRE-SE
        E FAÇA APOSTAS!`
    },
    de: {
      siteTitle: "Sportwetten | Zenit",
      btnLogin: "ANMELDEN",
      btnSignup: "Registrieren",
      title: "WETTEN MIT DEM BUCHMACHER ZENIT ABSCHLIESSEN",
      subtitle: "3 einfache Schritte, um mit dem Wetten zu beginnen:",
      stepTitle1: "Registrieren",
      stepSubtitle1: "Erstellen Sie ein Konto in nur wenigen Minuten.",
      stepTitle2: "Einzahlen",
      stepSubtitle2: "Tätigen Sie eine Einzahlung mit einer der verfügbaren Methoden.",
      stepTitle3: "WETTEN ABSCHLIESSEN",
      stepSubtitle3: "Wählen Sie die Ergebnisse und schließen Sie Wetten auf die wichtigsten Ereignisse ab.",
      btnGet: "Registrieren",
      regFormTitle: `Register
        and make bets!`
    },
    en: {
      siteTitle: "Sports betting | Zenit",
      btnLogin: "LOGIN",
      btnSignup: "REGISTER",
      title: "MAKE BETS WITH BOOKMAKER ZENIT",
      subtitle: "3 easy steps to start betting:",
      stepTitle1: "Register now",
      stepSubtitle1: "Create an account in just a few minutes.",
      stepTitle2: "Make a deposit",
      stepSubtitle2: "Make a deposit using any available method.",
      stepTitle3: "MAKE BETS",
      stepSubtitle3: "Choose outcomes and make bets on top events.",
      btnGet: "Register",
      regFormTitle: `Register
        and make bets!`
    },
    fr: {
      siteTitle: "Paris sportifs | Zenit",
      btnLogin: "SE CONNECTER",
      btnSignup: "S'ENREGISTRER",
      title: "PLACER DES PARIS AVEC BOOKMAKER ZENIT",
      subtitle: "3 étapes simples pour commencer à parier :",
      stepTitle1: "S'enregistrer",
      stepSubtitle1: "Créez un compte en seulement quelques minutes.",
      stepTitle2: `Effectuer des\xA0dépôts`,
      stepSubtitle2: "Effectuez un dépôt à l'aide de l'un des modes de dépôt disponibles.",
      stepTitle3: "PLACER DES PARIS",
      stepSubtitle3: "Choisissez les issues et placez des paris sur les principaux événements.",
      btnGet: "S'ENREGISTRER",
      regFormTitle: `Register
        and make bets!`
    },
    ir: {
      siteTitle: "شرط‌بندی ورزشی | بنگاه شرط‌بندی ZENIT",
      btnLogin: "ورود به سیستم",
      btnSignup: "ثبتنام",
      title: "با بنگاه Zenit شرط ببندید",
      subtitle: "در 3 مرحله ساده شروع به شرطبندی کنید:",
      stepTitle1: "ثبتنام",
      stepSubtitle1: "در چند دقیقه یک حساب کاربری ایجاد کنید",
      stepTitle2: "واریز",
      stepSubtitle2: "از هر روش ممکنی واریز کنید.",
      stepTitle3: "شرط ببندید",
      stepSubtitle3: "نتایج مختلف را پیشبینی کنید و روی رویدادهای مهم شرط ببندید",
      btnGet: "ثبتنام",
      regFormTitle: `Register
        and make bets!`
    },
    kz: {
      siteTitle: "Спортқа бәс тігу | Зенит букмекерлік кеңсесі",
      btnLogin: "КІРУ",
      btnSignup: "ТІРКЕЛУ",
      title: "ЗЕНИТ БК-ДЕ ҰТЫС ТІГУ",
      subtitle: "Бастауға арналған 3 қарапайым қадам:",
      stepTitle1: "ТІРКЕЛ ДЕ",
      stepSubtitle1: "Бірнеше минут ішінде аккаунтыңызды жаса.",
      stepTitle2: "Шотты толықтыру",
      stepSubtitle2: "Кез келген қолайлы тәсілмен балансқа қаражатты енгіз.",
      stepTitle3: "ҰТЫС ТІК",
      stepSubtitle3: "Нәтижелерді таңдап, үздік оқиғаларға тік.",
      btnGet: "ТІРКЕЛУ",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    mx: {
      siteTitle: "Apuesta deportiva | Zenit",
      btnLogin: "INICIAR SESIÓN",
      btnSignup: "REGISTRAR",
      title: "HAGA APUESTAS CON ZENIT BOOKMAKER",
      subtitle: "3 sencillos pasos para empezar a apostar:",
      stepTitle1: "Registrar",
      stepSubtitle1: "Cree una cuenta en unos cuantos minutos.",
      stepTitle2: "Hacer depósitos",
      stepSubtitle2: "Haga un depósito utilizando cualquier método disponible.",
      stepTitle3: "HAGA SUS APUESTAS",
      stepSubtitle3: "Elija los resultados y haga apuestas en los eventos más importantes.",
      btnGet: "REGISTRAR",
      regFormTitle: `Register
        and make bets!`
    },
    ru: {
      siteTitle: "Ставки на спорт | БК Зенит",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: "Делай ставки в БК Зенит",
      subtitle: "3 простых шага для начала:",
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Делай ставки",
      stepSubtitle3: "Выбирай исходы и ставь на лучшие события.",
      btnGet: "Зарегистрироваться",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    sw: {
      siteTitle: "Kuwekeza dau za michezo | Zenit",
      btnLogin: "WEKA JINA LA MTUMIAJI",
      btnSignup: "Jisajili",
      title: "WEKEZA DAU NA ALAMISHO ZENIT",
      subtitle: "Hatua 3 rahisi za kuanza kuwekeza dau:",
      stepTitle1: "Jisajili",
      stepSubtitle1: "Fanyiza akaunti kwa dakika chache tu.",
      stepTitle2: "Weka pesa",
      stepSubtitle2: "Weka pesa kupitia njia yoyote inayopatikana.",
      stepTitle3: "WEKEZA DAU",
      stepSubtitle3: "Chagua matokeo na uwekeze dau za matukio makuu.",
      btnGet: "Jisajili",
      regFormTitle: `Register
        and make bets!`
    },
    tr: {
      siteTitle: "Spor bahisleri | Zenit",
      btnLogin: "OTURUM AÇ",
      btnSignup: "Kaydolun",
      title: "ZENIT BAHİS ŞİRKETİ İLE BAHİSLER OYNAYIN",
      subtitle: "Bahis oynamaya başlamak için 3\xA0kolay adım:",
      stepTitle1: "Kaydolun",
      stepSubtitle1: "Sadece birkaç dakika içinde bir hesap oluşturun.",
      stepTitle2: "Para yatırın",
      stepSubtitle2: "Herhangi bir yöntemi kullanarak para yatırın.",
      stepTitle3: "BAHİSLER OYNAYIN",
      stepSubtitle3: "Sonuçları seçin ve en önemli olaylarda bahis oynayın.",
      btnGet: "Kaydolun",
      regFormTitle: `Register
        and make bets!`
    },
    uz: {
      siteTitle: "Sportga stavkalar | Zenit bukmekerlik kontorasi",
      btnLogin: "KIRISH",
      btnSignup: "Ro‘yxatdan o‘t",
      title: "ZENIT BK DA STAVKALAR QIL",
      subtitle: "Boshlash uchun 3 ta oddiy qadam:",
      stepTitle1: "Ro‘yxatdan o‘t",
      stepSubtitle1: "Atigi bir necha daqiqa ichida akkaunt yarat.",
      stepTitle2: "Hisobni to‘ldir",
      stepSubtitle2: "Nạp tiền bằng bất kỳ phương thức nào có sẵn.",
      stepTitle3: "STAVKALAR QIL",
      stepSubtitle3: "Natijalarni tanla va eng yaxshi hodisalarga tik.",
      btnGet: "Ro‘yxatdan o‘t",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    vi: {
      siteTitle: "Cá cược thể thao | Zenit",
      btnLogin: "ĐĂNG NHẬP",
      btnSignup: "Đăng ký",
      title: "ĐẶT CƯỢC VỚI NHÀ CÁI ZENIT",
      subtitle: "3 bước đơn giản để\xA0bắt đầu cá\xA0cược:",
      stepTitle1: "Đăng ký",
      stepSubtitle1: "Tạo tài khoản chỉ trong một vài phút.",
      stepTitle2: "Nạp tiền",
      stepSubtitle2: "Balansga mablag‘larni istalgan qulay usul bilan kirit.",
      stepTitle3: "ĐẶT CƯỢC",
      stepSubtitle3: "Chọn kết quả và đặt cược vào các sự kiện hàng đầu.",
      btnGet: "Đăng ký",
      regFormTitle: `Register
        and make bets!`
    }
  },
  zenbet: {
    ae: {
      siteTitle: "المراهنات الرياضية | ZENBET",
      btnLogin: "تسجيل الدخول",
      btnSignup: "سجّل",
      title: "راهن مع وكيل المراهنات ZENBET",
      subtitle: "3 خطوات بسيطة لتبدأ المراهنة:",
      stepTitle1: "سجّل",
      stepSubtitle1: "أنشئ حسابًا في بضع دقائق فقط",
      stepTitle2: "أودع",
      stepSubtitle2: "أودع باستخدام أي وسيلة متاحة",
      stepTitle3: "راهن",
      stepSubtitle3: "اختر النتائج وراهن على أفضل الأحداث",
      btnGet: "سجّل",
      regFormTitle: `Register
        and make bets!`
    },
    bn: {
      siteTitle: "ক্রীড়া বাজি | ZENBET",
      btnLogin: "সাইন ইন করুন",
      btnSignup: "নিবন্ধন করুন",
      title: "বুকমেকার ZENBET-এর সাথে বাজি ধরুন",
      subtitle: "বাজি শুরু করার 3 টি সহজ পদক্ষেপ:",
      stepTitle1: "নিবন্ধন করুন",
      stepSubtitle1: "মাত্র কয়েক মিনিটে অ্যাকাউন্ট তৈরি করুন।",
      stepTitle2: "জমা করুন",
      stepSubtitle2: "যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে জমা করুন।",
      stepTitle3: "বাজি ধরুন",
      stepSubtitle3: "ফলাফল বেছে নিন এবং শীর্ষ ইভেন্টগুলোতে বাজি ধরুন।",
      btnGet: "নিবন্ধন করুন",
      regFormTitle: `Register
        and make bets!`
    },
    br: {
      siteTitle: "Apostas esportivas | Bookmaker ZENBET",
      btnLogin: "LOGIN",
      btnSignup: "REGISTRE-SE",
      title: "FAÇA APOSTAS COM A CASA DE APOSTAS ZENBET",
      subtitle: "3 passos fáceis para começar a apostar:",
      stepTitle1: "REGISTRE-SE AGORA",
      stepSubtitle1: "Crie uma conta em alguns minutos.",
      stepTitle2: "Faça um depósito",
      stepSubtitle2: "Faça um depósito usando qualquer método disponível.",
      stepTitle3: "FAÇA APOSTAS",
      stepSubtitle3: "Escolha os resultados e faça apostas nos principais eventos.",
      btnGet: "REGISTRE-SE",
      regFormTitle: `REGISTRE-SE
        E FAÇA APOSTAS!`
    },
    de: {
      siteTitle: "Sportwetten | ZENBET",
      btnLogin: "ANMELDEN",
      btnSignup: "Registrieren",
      title: "WETTEN MIT DEM BUCHMACHER ZENBET ABSCHLIESSEN",
      subtitle: "3 einfache Schritte, um mit dem Wetten zu beginnen:",
      stepTitle1: "Registrieren",
      stepSubtitle1: "Erstellen Sie ein Konto in nur wenigen Minuten.",
      stepTitle2: "Einzahlen",
      stepSubtitle2: "Tätigen Sie eine Einzahlung mit einer der verfügbaren Methoden.",
      stepTitle3: "WETTEN ABSCHLIESSEN",
      stepSubtitle3: "Wählen Sie die Ergebnisse und schließen Sie Wetten auf die wichtigsten Ereignisse ab.",
      btnGet: "Registrieren",
      regFormTitle: `Register
        and make bets!`
    },
    en: {
      siteTitle: "Sports bets | ZENBET",
      btnLogin: "LOGIN",
      btnSignup: "REGISTER",
      title: "MAKE BETS WITH BOOKMAKER ZENBET",
      subtitle: "3 easy steps to start betting:",
      stepTitle1: "Register now",
      stepSubtitle1: "Create an account in just a few minutes.",
      stepTitle2: "Make a deposit",
      stepSubtitle2: "Make a deposit using any available method.",
      stepTitle3: "MAKE BETS",
      stepSubtitle3: "Choose outcomes and make bets on top events.",
      btnGet: "Register",
      regFormTitle: `Register
        and make bets!`
    },
    fr: {
      siteTitle: "Paris sportifs | ZENBET",
      btnLogin: "SE CONNECTER",
      btnSignup: "S'ENREGISTRER",
      title: "PLACER DES PARIS AVEC BOOKMAKER ZENBET",
      subtitle: "3 étapes simples pour commencer à parier :",
      stepTitle1: "S'enregistrer",
      stepSubtitle1: "Créez un compte en seulement quelques minutes.",
      stepTitle2: `Effectuer des\xA0dépôts`,
      stepSubtitle2: "Effectuez un dépôt à l'aide de l'un des modes de dépôt disponibles.",
      stepTitle3: "PLACER DES PARIS",
      stepSubtitle3: "Choisissez les issues et placez des paris sur les principaux événements.",
      btnGet: "S'ENREGISTRER",
      regFormTitle: `Register
        and make bets!`
    },
    ir: {
      siteTitle: "شرط‌بندی ورزشی | بنگاه شرط‌بندی ZENBET",
      btnLogin: "ورود به سیستم",
      btnSignup: "ثبتنام",
      title: "با بنگاه ZENBET شرط ببندید",
      subtitle: "در 3 مرحله ساده شروع به شرطبندی کنید:",
      stepTitle1: "ثبتنام",
      stepSubtitle1: "در چند دقیقه یک حساب کاربری ایجاد کنید",
      stepTitle2: "واریز",
      stepSubtitle2: "از هر روش ممکنی واریز کنید.",
      stepTitle3: "شرط ببندید",
      stepSubtitle3: "نتایج مختلف را پیشبینی کنید و روی رویدادهای مهم شرط ببندید",
      btnGet: "ثبتنام",
      regFormTitle: `Register
        and make bets!`
    },
    kz: {
      siteTitle: "Спортқа бәс тігу | ZENBET букмекерлік кеңсесі",
      btnLogin: "КІРУ",
      btnSignup: "ТІРКЕЛУ",
      title: "ZENBET БК-ДЕ ҰТЫС ТІГУ",
      subtitle: "Бастауға арналған 3 қарапайым қадам:",
      stepTitle1: "ТІРКЕЛ ДЕ",
      stepSubtitle1: "Бірнеше минут ішінде аккаунтыңызды жаса.",
      stepTitle2: "Шотты толықтыру",
      stepSubtitle2: "Кез келген қолайлы тәсілмен балансқа қаражатты енгіз.",
      stepTitle3: "ҰТЫС ТІК",
      stepSubtitle3: "Нәтижелерді таңдап, үздік оқиғаларға тік.",
      btnGet: "ТІРКЕЛУ",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    mx: {
      siteTitle: "Apuesta deportiva | ZENBET",
      btnLogin: "INICIAR SESIÓN",
      btnSignup: "REGISTRAR",
      title: "HAGA APUESTAS CON ZENBET BOOKMAKER",
      subtitle: "3 sencillos pasos para empezar a apostar:",
      stepTitle1: "Registrar",
      stepSubtitle1: "Cree una cuenta en unos cuantos minutos.",
      stepTitle2: "Hacer depósitos",
      stepSubtitle2: "Haga un depósito utilizando cualquier método disponible.",
      stepTitle3: "HAGA SUS APUESTAS",
      stepSubtitle3: "Elija los resultados y haga apuestas en los eventos más importantes.",
      btnGet: "REGISTRAR",
      regFormTitle: `Register
        and make bets!`
    },
    ru: {
      siteTitle: "Ставки на спорт | ZENBET",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: "Делай ставки в БК ZENBET",
      subtitle: "3 простых шага для начала:",
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Делай ставки",
      stepSubtitle3: "Выбирай исходы и ставь на лучшие события.",
      btnGet: "Зарегистрироваться",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    sw: {
      siteTitle: "Kuwekeza dau za michezo | ZENBET",
      btnLogin: "WEKA JINA LA MTUMIAJI",
      btnSignup: "Jisajili",
      title: "WEKEZA DAU NA ALAMISHO ZENBET",
      subtitle: "Hatua 3 rahisi za kuanza kuwekeza dau:",
      stepTitle1: "Jisajili",
      stepSubtitle1: "Fanyiza akaunti kwa dakika chache tu.",
      stepTitle2: "Weka pesa",
      stepSubtitle2: "Weka pesa kupitia njia yoyote inayopatikana.",
      stepTitle3: "WEKEZA DAU",
      stepSubtitle3: "Chagua matokeo na uwekeze dau za matukio makuu.",
      btnGet: "Jisajili",
      regFormTitle: `Register
        and make bets!`
    },
    tr: {
      siteTitle: "Spor bahisleri | ZENBET",
      btnLogin: "OTURUM AÇ",
      btnSignup: "Kaydolun",
      title: "ZENBET BAHİS ŞİRKETİ İLE BAHİSLER OYNAYIN",
      subtitle: "Bahis oynamaya başlamak için 3\xA0kolay adım:",
      stepTitle1: "Kaydolun",
      stepSubtitle1: "Sadece birkaç dakika içinde bir hesap oluşturun.",
      stepTitle2: "Para yatırın",
      stepSubtitle2: "Herhangi bir yöntemi kullanarak para yatırın.",
      stepTitle3: "BAHİSLER OYNAYIN",
      stepSubtitle3: "Sonuçları seçin ve en önemli olaylarda bahis oynayın.",
      btnGet: "Kaydolun",
      regFormTitle: `Register
        and make bets!`
    },
    uz: {
      siteTitle: "Sportga stavkalar | ZENBET bukmekerlik kontorasi",
      btnLogin: "KIRISH",
      btnSignup: "Ro‘yxatdan o‘t",
      title: "ZENBET BK DA STAVKALAR QIL",
      subtitle: "Boshlash uchun 3 ta oddiy qadam:",
      stepTitle1: "Ro‘yxatdan o‘t",
      stepSubtitle1: "Atigi bir necha daqiqa ichida akkaunt yarat.",
      stepTitle2: "Hisobni to‘ldir",
      stepSubtitle2: "Nạp tiền bằng bất kỳ phương thức nào có sẵn.",
      stepTitle3: "STAVKALAR QIL",
      stepSubtitle3: "Natijalarni tanla va eng yaxshi hodisalarga tik.",
      btnGet: "Ro‘yxatdan o‘t",
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    vi: {
      siteTitle: "Cá cược thể thao | ZENBET",
      btnLogin: "ĐĂNG NHẬP",
      btnSignup: "Đăng ký",
      title: "ĐẶT CƯỢC VỚI NHÀ CÁI ZENBET",
      subtitle: "3 bước đơn giản để\xA0bắt đầu cá\xA0cược:",
      stepTitle1: "Đăng ký",
      stepSubtitle1: "Tạo tài khoản chỉ trong một vài phút.",
      stepTitle2: "Nạp tiền",
      stepSubtitle2: "Balansga mablag‘larni istalgan qulay usul bilan kirit.",
      stepTitle3: "ĐẶT CƯỢC",
      stepSubtitle3: "Chọn kết quả và đặt cược vào các sự kiện hàng đầu.",
      btnGet: "Đăng ký",
      regFormTitle: `Register
        and make bets!`
    }
  }
}